import React from 'react';
import { connect } from 'react-redux';
import {
  toggleAllPassengersExpanded,
} from 'store/actions';

import { DotButton } from 'components';

const ExpandAllContainer = props => <DotButton {...props} />;

const mapDispatchToProps = dispatch => ({
  onClick: () => dispatch(toggleAllPassengersExpanded()),
});

export default connect(null, mapDispatchToProps)(ExpandAllContainer);



// WEBPACK FOOTER //
// ./src/containers/ExpandAllButton.js